import './wizardProgress.scss';
import './wizardProgress.tpl.html';

angular.module('shared.wizardProgress', []).directive('wizardProgress', () => ({
  restrict: 'E',
  link: ($scope, element, { stepCount, currentStep }) => {
    $scope.stepCount = +stepCount;
    $scope.currentStepIndex = +currentStep - 1;
  },
  templateUrl: 'shared/wizardProgress/wizardProgress.tpl.html'
}));
